import { get, post } from 'api';
import config from 'config';

const webAPIUrl = config.get('api.webAPI');

const authenticateUser = async (dealerId: string, userName: string, password: string, token: string): Promise<any> => {
    const { data } = await post(`${webAPIUrl}/Authentication/authentication`, {
        dealerId,
        userName,
        password,
    token,
  });
    return data;
};

const refreshTokenUser = async (refreshToken: string): Promise<any> => {
  const { data } = await post(`${webAPIUrl}/Authentication/refreshToken`, { refreshToken });
  return data;
};

const validateTokenUser = async (): Promise<any> => {
  const { data } = await get(`${webAPIUrl}/Authentication/validateToken`);
  return data;
};

const getPreLoginToken = async (): Promise<any> => {
  const { data } = await get(`${webAPIUrl}/Authentication/preLoginToken`);
  return data;
};

export default { authenticateUser, refreshTokenUser, validateTokenUser, getPreLoginToken };
